var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accessibility-widget", style: _vm.panelStyles },
    [
      _c(
        "button",
        {
          ref: "accessibilityButton",
          staticClass: "accessibility-toggle-btn",
          class: { active: _vm.isPanelOpen },
          attrs: {
            "aria-label": _vm.isPanelOpen
              ? "Fechar painel de acessibilidade"
              : "Abrir painel de acessibilidade",
            "aria-expanded": _vm.isPanelOpen,
            tabindex: "0"
          },
          on: { click: _vm.togglePanel }
        },
        [
          _c("i", {
            staticClass: "feather icon-eye",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _c("transition", { attrs: { name: "slide-up" } }, [
        _vm.isPanelOpen
          ? _c(
              "div",
              {
                staticClass: "accessibility-panel",
                style: _vm.panelStyles,
                attrs: {
                  role: "dialog",
                  "aria-labelledby": "accessibility-panel-title"
                }
              },
              [
                _c("div", { staticClass: "panel-header" }, [
                  _c(
                    "h3",
                    {
                      staticClass: "panel-title",
                      attrs: { id: "accessibility-panel-title" }
                    },
                    [
                      _c("i", {
                        staticClass: "feather icon-eye mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Acessibilidade ")
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "close-btn",
                      attrs: {
                        "aria-label": "Fechar painel de acessibilidade",
                        tabindex: "0"
                      },
                      on: { click: _vm.closePanel }
                    },
                    [
                      _c("i", {
                        staticClass: "feather icon-x",
                        attrs: { "aria-hidden": "true" }
                      })
                    ]
                  )
                ]),
                _c("div", { staticClass: "panel-content" }, [
                  _c("div", { staticClass: "control-group" }, [
                    _c("h4", { staticClass: "control-title" }, [
                      _c("i", {
                        staticClass: "feather icon-type mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Tamanho da Fonte ")
                    ]),
                    _c("div", { staticClass: "control-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "control-btn",
                          attrs: {
                            disabled: _vm.fontSize <= _vm.minFontSize,
                            "aria-label": "Diminuir tamanho da fonte",
                            tabindex: "0"
                          },
                          on: { click: _vm.decreaseFontSize }
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-minus",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("span", [_vm._v("A-")])
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "font-size-display",
                          class: { "font-size-changed": _vm.fontSizeChanged },
                          attrs: { "aria-live": "polite" }
                        },
                        [_vm._v(_vm._s(_vm.fontSize) + "%")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "control-btn",
                          attrs: {
                            disabled: _vm.fontSize >= _vm.maxFontSize,
                            "aria-label": "Aumentar tamanho da fonte",
                            tabindex: "0"
                          },
                          on: { click: _vm.increaseFontSize }
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-plus",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("span", [_vm._v("A+")])
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "control-group" }, [
                    _c("h4", { staticClass: "control-title" }, [
                      _c("i", {
                        staticClass: "feather icon-sun mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Contraste ")
                    ]),
                    _c("div", { staticClass: "control-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "control-btn toggle-btn",
                          class: { active: _vm.isHighContrast },
                          attrs: {
                            "aria-label": _vm.isHighContrast
                              ? "Desativar alto contraste"
                              : "Ativar alto contraste",
                            "aria-pressed": _vm.isHighContrast,
                            tabindex: "0"
                          },
                          on: { click: _vm.toggleHighContrast }
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-moon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("span", [_vm._v("Alto Contraste")])
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "control-group" }, [
                    _c("h4", { staticClass: "control-title" }, [
                      _c("i", {
                        staticClass: "feather icon-volume-2 mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Leitura de Texto ")
                    ]),
                    _c("div", { staticClass: "control-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "control-btn toggle-btn",
                          class: { active: _vm.isTextToSpeechEnabled },
                          attrs: {
                            "aria-label": _vm.isTextToSpeechEnabled
                              ? "Desativar leitura de texto"
                              : "Ativar leitura de texto",
                            "aria-pressed": _vm.isTextToSpeechEnabled,
                            tabindex: "0"
                          },
                          on: { click: _vm.toggleTextToSpeech }
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-headphones",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("span", [_vm._v("Narração")])
                        ]
                      ),
                      _vm.isTextToSpeechEnabled
                        ? _c(
                            "button",
                            {
                              staticClass: "control-btn",
                              attrs: {
                                "aria-label": "Ler conteúdo da página",
                                tabindex: "0"
                              },
                              on: { click: _vm.readPageContent }
                            },
                            [
                              _c("i", {
                                staticClass: "feather icon-play",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _c("span", [_vm._v("Ler Página")])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _c("div", { staticClass: "control-group" }, [
                    _c("h4", { staticClass: "control-title" }, [
                      _c("i", {
                        staticClass: "feather icon-navigation mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Navegação ")
                    ]),
                    _c("div", { staticClass: "control-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "control-btn toggle-btn",
                          class: { active: _vm.isKeyboardNavigationEnhanced },
                          attrs: {
                            "aria-label": _vm.isKeyboardNavigationEnhanced
                              ? "Desativar navegação aprimorada"
                              : "Ativar navegação aprimorada",
                            "aria-pressed": _vm.isKeyboardNavigationEnhanced,
                            tabindex: "0"
                          },
                          on: { click: _vm.toggleKeyboardNavigation }
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-command",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("span", [_vm._v("Navegação++")])
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "control-group" }, [
                    _c("h4", { staticClass: "control-title" }, [
                      _c("i", {
                        staticClass: "feather icon-book-open mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Interface ")
                    ]),
                    _c("div", { staticClass: "control-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "control-btn toggle-btn",
                          class: { active: _vm.isReadingMode },
                          attrs: {
                            "aria-label": _vm.isReadingMode
                              ? "Desativar modo leitura"
                              : "Ativar modo leitura",
                            "aria-pressed": _vm.isReadingMode,
                            tabindex: "0"
                          },
                          on: { click: _vm.toggleReadingMode }
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-eye-off",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _c("span", [_vm._v("Modo Leitura")])
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "control-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "control-btn reset-btn",
                        attrs: {
                          "aria-label":
                            "Restaurar configurações padrão de acessibilidade",
                          tabindex: "0"
                        },
                        on: { click: _vm.resetAccessibilitySettings }
                      },
                      [
                        _c("i", {
                          staticClass: "feather icon-refresh-cw mr-2",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" Restaurar Padrão ")
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "control-group" }, [
                    _c("h4", { staticClass: "control-title" }, [
                      _c("i", {
                        staticClass: "feather icon-keyboard mr-2",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Atalhos de Teclado ")
                    ]),
                    _c("div", { staticClass: "shortcuts-info" }, [
                      _c("small", [
                        _c("strong", [_vm._v("Alt + A:")]),
                        _vm._v(" Abrir/Fechar Painel"),
                        _c("br"),
                        _c("strong", [_vm._v("Alt + +:")]),
                        _vm._v(" Aumentar Fonte"),
                        _c("br"),
                        _c("strong", [_vm._v("Alt + -:")]),
                        _vm._v(" Diminuir Fonte"),
                        _c("br"),
                        _c("strong", [_vm._v("Alt + C:")]),
                        _vm._v(" Alto Contraste"),
                        _c("br"),
                        _c("strong", [_vm._v("Alt + S:")]),
                        _vm._v(" Narração"),
                        _c("br"),
                        _c("strong", [_vm._v("ESC:")]),
                        _vm._v(" Fechar Painel ")
                      ])
                    ])
                  ]),
                  _vm.statusMessage
                    ? _c(
                        "div",
                        {
                          staticClass: "status-message",
                          attrs: { role: "status", "aria-live": "polite" }
                        },
                        [_vm._v(" " + _vm._s(_vm.statusMessage) + " ")]
                      )
                    : _vm._e()
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm.isPanelOpen
        ? _c("div", {
            staticClass: "accessibility-overlay",
            attrs: { "aria-hidden": "true" },
            on: { click: _vm.closePanel }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }